<template>
  <div id="app">
      <div class="loadcon" v-if="loading">
        <van-loading type="spinner" />
      </div>
      <router-view />
      <van-tabbar v-if='isshowed' v-model="activeTabName" active-color="#EE0A24" @change="switchTab">
          <van-tabbar-item name="index" >
            <span>首页</span>
            <template #icon="props">
              <van-icon :name="CurRouteName=='index'||CurRouteName=='home' ? 'wap-home' : 'wap-home-o'" />
            </template>
          </van-tabbar-item>
          <van-tabbar-item name="shoplist">
            <span>订货</span>
            <template #icon="props">
                <van-icon :name="CurRouteName=='shoplist' ? 'shopping-cart' : 'shopping-cart-o'"/>
            </template>
         </van-tabbar-item>
          <van-tabbar-item name="fahuo">
              <span>发货</span>
              <template #icon="props">
                  <van-icon :name="CurRouteName=='fahuo' ? 'bag' : 'bag-o'" />
              </template>
          </van-tabbar-item>
          <van-tabbar-item name="my">
             <span>我的</span>
              <template #icon="props">
                  <van-icon :name="CurRouteName=='my' ? 'gem' : 'gem-o'" />
              </template>
          </van-tabbar-item>
      </van-tabbar>
  </div>
</template>
<script>
import { Tabbar, TabbarItem,Icon,Loading} from 'vant';
export default {
   name: 'index',
   data() {
      return {
        activeTabName:'index'
      }
   },
   watch:{
       $route(){
          if(this.$route.name!=this.activeTabName) {
              this.activeTabName=this.$route.name=='home'?'index':this.$route.name
          }
      }
   },
   computed:{
       isshowed:function(){
           const TabbarList=['index','home','shoplist','my','fahuo']
           if(TabbarList.includes(this.$route.name)){
               return true
           }else{
               return false
           }
       },
       loading(){
          return this.$store.state.app.loading
       },
       fahuonums(){
          return this.$store.state.app.fahuonums
       },
       CurRouteName(){
          return this.$route.name
       }
   },
   methods:{
      switchTab(){
         this.$go('/'+this.activeTabName)
      }
   },
   components: {
        [Icon.name]: Icon,
        [Tabbar.name]: Tabbar,
        [TabbarItem.name]: TabbarItem,
        [Loading.name]:Loading
   }
}
</script>
<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.loadcon{display: flex;justify-content: center;align-items: center;position: absolute;left:0;top:0;width:100%;height:100vh;z-index:9999;}
</style>
